import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Title-case a person's name: lowercases then capitalizes each word.
 * Preserves spacing and hyphens (e.g. "mary-jane van houten" → "Mary-Jane Van Houten").
 */
export function toTitleCase(name: string | null | undefined): string {
  if (!name) return name ?? "";
  return name
    .toLowerCase()
    .split(/(\s+|-)/)
    .map((part) => (part.trim() && part !== "-" ? part.charAt(0).toUpperCase() + part.slice(1) : part))
    .join("");
}
